"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M2 2v6h1v2H.8a.8.8 0 01-.8-.8V.8A.8.8 0 01.8 0h14.4a.8.8 0 01.8.8v8.4a.8.8 0 01-.8.8H13V8h1V2H2zm7 9h2c.55 0 1 .45 1 1s-.45 1-1 1H9v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H5c-.55 0-1-.45-1-1s.45-1 1-1h2V9c0-.55.45-1 1-1s1 .45 1 1v2z"];
//# sourceMappingURL=add-child.js.map